import type { TestimonialModuleType } from "./types";
import MultiColumnModule from "../../MultiColumnModule";
import TestimonialVariant1 from "./TestimonialVariant1";

export interface TestimonialModuleProps {
  module: TestimonialModuleType;
}

export default function TestimonialModule(props: TestimonialModuleProps) {
  const { module } = props;

  return (
    <MultiColumnModule
      module={module}
      renderBlock={(block) => <TestimonialVariant1 block={block} />}
    />
  );
}
